/**
 * Sanitizes a value to extract a numeric string.
 *
 * @param value The value to sanitize. Can be of any type.
 * @returns The sanitized numeric string, or the original value if it's not string-like (e.g., null, undefined, number).
 */
export const sanitizeToNumericString = (value: any): any => {
  try {
    let result = value.replace(/,/g, '.');
    result = result.replace(/^\.+/g, '0.');
    result = result.replace(/^([^\.]*\.)|\./g, '$1');
    result = result.replace(/[^.\s\d]+/g, '');
    result = result.replaceAll(' ', '');
    result = result.replace(/\.$/, ''); // Remove trailing dot
    return result;
  } catch (err) {
    return value;
  }
};
